import React from 'react'
/*
    this class use the react Components to administrate one input using react Components
*/
interface SettingsTextInputProps
{
	name: string
	label: string
	value: string
	error: string
    placeholder: string
	handleChange(event: React.FormEvent<HTMLInputElement>): void
}

interface SettingsTextInputState
{

}

export default class SettingsTextInput extends React.Component<SettingsTextInputProps, SettingsTextInputState> {
	
	constructor(props: SettingsTextInputProps) {
        super(props);
        this.state = {
        };
    }
	
	render() {
        return (
            <div>
                <div className="row">
                    <label className="col-md-4">
                        {this.props.label}
                    </label>
                    <div className="col-md-8">
                        <input
							name={this.props.name}
                            type={"text"}
                            value={this.props.value}
                            style={{border: this.props.error === "" ? "1px solid #ddd" : "1px solid red"}}
                            onChange={this.props.handleChange}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8 offset-md-4">
                        {this.props.error}
                    </div>
                </div>
            </div>
        );
    }
}